import React from "react";
import { useNavigate } from "react-router-dom";
import { Star, Gift } from "lucide-react";
import { LOGO_URL } from "../mock";
import { resolveImageUrl } from "../api";

const NAVY = "#1B1F5C";

const Stars = ({ rating }) => (
  <span className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={12} className={i <= Math.round(rating) ? "text-[#F79433] fill-[#F79433]" : "text-gray-300 fill-gray-300"} />
    ))}
  </span>
);

const ProductCard = ({ product, badgeColor = "#4CAF50", wishlist, toggleWishlist, addToCart }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate(`/product/${product.id}`)}
      className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-transform duration-200 overflow-hidden flex flex-col group cursor-pointer"
    >
      <div className="relative bg-[#F7F7FA] p-4">
        {product.inStock === false && (
          <span className="absolute top-3 left-3 z-10 text-white text-[10px] font-extrabold px-2 py-0.5 rounded bg-gray-500">
            OUT OF STOCK
          </span>
        )}
        {product.giftCard ? (
          <div className="h-40 w-full flex items-center justify-center">
            <div className="relative w-[85%] aspect-[16/10] rounded-xl shadow-lg flex flex-col items-center justify-center gap-1" style={{ backgroundColor: NAVY }}>
              <Gift size={22} className="text-[#FCD44E] absolute top-2 right-3" />
              <img src={LOGO_URL} alt="Adhira & Appa Toys" className="h-14 w-auto bg-white rounded-lg px-2 py-1" />
              <span className="text-white text-[10px] font-extrabold tracking-[0.25em] mt-1">GIFT CARD</span>
            </div>
          </div>
        ) : (
          <img src={resolveImageUrl(product.image)} alt={product.name} className="h-40 w-full object-contain mix-blend-multiply group-hover:scale-105 transition-transform duration-300" loading="lazy" />
        )}
      </div>
      <div className="p-4 pt-3 text-left flex flex-col flex-1">
        <p className="text-[13px] font-bold leading-snug min-h-[36px]" style={{ color: NAVY }}>{product.name}</p>
        <div className="mt-1.5 flex items-center gap-1.5">
          <Stars rating={product.rating} />
          <span className="text-[11px] font-semibold text-gray-400">({product.reviews})</span>
        </div>
        <button
          onClick={(e) => { e.stopPropagation(); navigate(`/product/${product.id}`); }}
          data-testid={`discover-btn-${product.id}`}
          className="mt-3 w-full h-9 rounded-md text-white text-[12px] font-extrabold tracking-wide hover:opacity-90 transition-opacity"
          style={{ backgroundColor: NAVY }}
        >
          Discover More
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
